import React, {Component, PropType} from 'react'

class LoadingComponent extends React.Component{
    constructor(props){
        super(props);

        this.generateLoader = this.generateLoader.bind(this);
    }
    componentDidMount() {
        if(document.readyState == 'complete'){
            jQuery('.loaderdiv').addClass('loader-div');
        } else {
            jQuery(window).on('load',function () {            
            jQuery('.loaderdiv').addClass('loader-div');
        });
        }        
    }

    generateLoader(){
        var loader = (<>
        <div className='d-flex justify-content-center mg-t-100'>
            <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
            <span className='d-flex justify-content-center mg-t-10'>Please wait while the data is loading...</span>
        </>
        );
        if(this.props.type == "feedback"){
           loader = (<div className="text-center">
                <div className="spinner-border"></div>
            </div>);
        }
        return loader;
    }
    render() {
        var loader = this.generateLoader();
        return loader;
    }
}

export default LoadingComponent;